import { __rest } from "tslib";
import {} from './logging-service.js';
export function identity(x) {
    return x;
}
function isPlainObject(obj) {
    return obj && typeof obj == 'object' && !obj.nodeType;
}
function unwrapJSON(data) {
    if (typeof data == 'string' && (/^\[.*\]$/.test(data) || /^\{.*\}$/.test(data))) {
        try {
            return JSON.parse(data);
        }
        catch (e) {
            // ignored
        }
    }
    return Array.isArray(data) ? data.slice() : isPlainObject(data) ? Object.assign({}, data) : data;
}
export function flatten(message) {
    if ((message === null || message === void 0 ? void 0 : message.data) === undefined) {
        return message;
    }
    const { data } = message, messageClone = __rest(message, ["data"]);
    const unwrappedData = unwrapJSON(data);
    if (!Array.isArray(unwrappedData)) {
        messageClone.data = data;
    }
    else {
        // if there is only 1 data object, flatten into message if possible
        if (unwrappedData.length === 1) {
            const unwrappedEntry = unwrapJSON(unwrappedData[0]);
            if (typeof unwrappedEntry == 'object') {
                try {
                    const keys = Object.keys(unwrappedEntry);
                    const conflict = keys.some(function (key) {
                        // eslint-disable-next-line no-prototype-builtins
                        if (message.hasOwnProperty(key)) {
                            return true;
                        }
                        return false;
                    });
                    if (!conflict) {
                        keys.forEach(function (key) {
                            messageClone[key] = unwrappedEntry[key];
                        });
                        unwrappedData.shift();
                    }
                }
                catch (e) {
                    // silently ignore
                }
            }
        }
        if (unwrappedData.length) {
            messageClone.data = unwrappedData;
        }
    }
    return messageClone;
}
//# sourceMappingURL=logging-service-utils.js.map